import { lazy, Suspense, useEffect, useState } from "react";
// Components
import Index from "./jsx/index";
import { useNavigate } from "react-router-dom";
import { useAuth0 } from "@auth0/auth0-react";
// Actions
import { connect, useDispatch, useSelector } from "react-redux";
// Style
import "../node_modules/bootstrap-select/dist/css/bootstrap-select.min.css";
import "./css/style.css";
import ProfileData from "./jsx/pages/ProfileData";
import { loginConfirmedAction } from "./store/actions/AuthActions";
import { auth, users } from "./services/api/models";
import { useAuthHelper } from "./hooks/useAuthHelper";

function App() {
  const { auth } = useSelector((state) => state.auth);
  const { isAuthenticated, isLoading, loginWithRedirect, user } = useAuth0();
  const { getSafeAccessToken, isTokenExpired } = useAuthHelper();
  const dispatch = useDispatch();
  const [isInitializing, setIsInitializing] = useState(false);

  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const state = queryParams.get("state");
  
    if (!isAuthenticated && !isLoading) {
      if (state) {
        loginWithRedirect({appState: {returnTo: `/quest-view/${state}`}});
      } else {
        loginWithRedirect({appState: {returnTo: "/"}});
      }
    }
  }, [isAuthenticated, isLoading, loginWithRedirect]);

  useEffect(() => {
    const storeUserData = async () => {
      if (isAuthenticated && Object.keys(auth.user).length === 0) {
        setIsInitializing(true);
        
        try {
          const accessToken = await getSafeAccessToken();
          
          // If token is null, redirect is happening
          if (!accessToken) {
            return;
          }
          
          // Get database user
          const headers = { Authorization: `Bearer ${accessToken}` }
          const options = { headers: headers }
          const dbUser = await users.usersGet(1, 0, {auth0Id: user.sub}, options);
          
          if (dbUser.data.data.length !== 0) {
            const dbUserData = dbUser.data.data[0];
            const mergedUser = {
              ...user,
              ...Object.keys(dbUserData).reduce((acc, key) => {
                if (dbUserData.hasOwnProperty(key)) { 
                  acc[key] = dbUserData[key] ?? user[key] ?? "";
                }
                return acc;
              }, {}),
            };
            dispatch(loginConfirmedAction({ user: mergedUser, accessToken }));
          }
        } catch (error) {
          console.log('Error during user data initialization:', error.message);
        } finally {
          setIsInitializing(false);
        }
      }
    };
    
    if (isAuthenticated && Object.keys(auth.user).length === 0) {
      storeUserData();
    }
  }, [isAuthenticated, auth.user, user, getSafeAccessToken, dispatch]);
  if (isLoading || isInitializing || isTokenExpired) {
    return (
      <div id="preloader">
        <div className="sk-three-bounce">
          <div className="sk-child sk-bounce1"></div>
          <div className="sk-child sk-bounce2"></div>
          <div className="sk-child sk-bounce3"></div>
        </div>
      </div>
    );
  }

  // user is authenticated by auth0, but hasn't chosen a role yet

   //console.log("before if user : ++++++++++++++++++++++++++++", user);
   //console.log("Redux full user info : ++++++++++++++++++++++++++++", auth.user);
  if (isAuthenticated && (!auth.user.role || !auth.user.whatsAppPhoneNumber)) {
    return (
      <Suspense
        fallback={
          <div id="preloader">
            <div className="sk-three-bounce">
              <div className="sk-child sk-bounce1"></div>
              <div className="sk-child sk-bounce2"></div>
              <div className="sk-child sk-bounce3"></div>
            </div>
          </div>
        }
      >
        <ProfileData />
      </Suspense>
    );
  }
  else if (isAuthenticated) {
    return (
      <Suspense
        fallback={
          <div id="preloader">
            <div className="sk-three-bounce">
              <div className="sk-child sk-bounce1"></div>
              <div className="sk-child sk-bounce2"></div>
              <div className="sk-child sk-bounce3"></div>
            </div>
          </div>
        }
      >
        <Index />
      </Suspense>
    );
  }

  return null;
}

export default App;
